import { render } from "./ImpressaoAnexos.vue?vue&type=template&id=14f452b8&scoped=true"
import script from "./ImpressaoAnexos.vue?vue&type=script&lang=js"
export * from "./ImpressaoAnexos.vue?vue&type=script&lang=js"

import "./ImpressaoAnexos.vue?vue&type=style&index=0&id=14f452b8&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f452b8"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
